module.exports = __webpack_public_path__ + "static/media/cluster_2.dbf6f01b.webp";